import React from "react";

import { RushaSvgIcon } from "./RushaSvgIcon";

/**
 * Database cylinder icon.
 *
 * A standard database cylinder shape: top ellipse, two curved side
 * paths forming the body, and a bottom curve. Represents a data store.
 *
 * Dual-tone layered:
 * - Outlines: currentColor, 2px stroke, round caps/joins
 * - Top ellipse: cyan accent fill at 12%
 * - Bottom curve: 30% opacity outline
 */
export const DatabaseIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <RushaSvgIcon size={size}>
    {/* Top ellipse with cyan accent fill */}
    <ellipse
      cx="12"
      cy="5"
      rx="8"
      ry="3"
      fill="#00d4ff"
      fillOpacity={0.12}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Left side curve of the cylinder body */}
    <path
      d="M4 5 L4 19 C4 20.66 7.58 22 12 22"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Right side curve of the cylinder body */}
    <path
      d="M20 5 L20 19 C20 20.66 16.42 22 12 22"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Bottom curve at 30% opacity */}
    <path
      d="M4 12 C4 13.66 7.58 15 12 15 C16.42 15 20 13.66 20 12"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity={0.3}
    />
  </RushaSvgIcon>
);

DatabaseIcon.displayName = "DatabaseIcon";

export default DatabaseIcon;
